<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.col-xl-3.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-gamepad
          ProviderLookup(
            v-if="displayTable"
            size="sm"
            type="array"
            :operatorID="operatorID"
            v-model="provider"
            :disabled="loading"
            category="SPORTSBOOK"
            :isAll="true"
            :isReport="true"
            @input="getGameResult(true)"
          )
      .form-group.col-12.col-xl-4
        b-input-group(size="sm")
          b-input-group-text(slot="prepend" :title="$t('ui.created_date')")
            span {{ $t('ui.created_date') }}
          b-input-group-text(slot="append")
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="searchCreatedDate" @change="getGameResult(true)")
              span.custom-switch-indicator
      //- .form-group.col-12.col-xl-6.mb-1
      .form-group.col-12
        DateRangePicker(:value="dateRange" @update="getData" v-if="displayTable")
      .form-group.col-12.mb-1
        SubmitButton.mr-2(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getGameResult(true)"
          variant="primary"
          size="sm"
        )
        jsonToExcel(v-if="gameResultList.length > 0" mode="GameResultSportsbook" tbl="tblGameResultSportsbook" :date="dateRange")
        gameResultSportsbookExport(v-if="gameResultList.length > 0" :tbl="gameResultList" :totalTbl="grandTotalList" tblId="tblGameResultSportsbook")
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-resizable#tblGameResultSportsbook(style="width:100%;" v-if="displayTable")
            thead.thead-light(v-columns-resizable)
              tr
                th.text-center.sticky-position(width="3%")
                  span #
                th.sticky-position.sortable(width="16%" @click="sortOrder('bet_time')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.date_time')") {{ $t('ui.date_time') }}
                    i(:class="changeSortKey('bet_time')")
                th.sticky-position(width="9%")
                  span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                th.sticky-position(width="9%")
                  span(:title="$t('ui.sports_game')") {{ $t('ui.sports_game') }}
                th.sticky-position(width="20%")
                  span(:title="$t('ui.event')") {{ $t('ui.event') }}
                th.sticky-position(width="10%")
                  span(:title="$t('ui.detail')") {{ $t('ui.detail') }}
                th.sticky-position.text-right.sortable(width="8%" @click="sortOrder('turnover')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                    i(:class="changeSortKey('turnover')")
                th.sticky-position.text-right.sortable(width="9%" @click="sortOrder('valid_turnover')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                    i(:class="changeSortKey('valid_turnover')")
                th.sticky-position.text-right.sortable(width="8%" @click="sortOrder('payout')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.payout')") {{ $t('ui.payout') }}
                    i(:class="changeSortKey('payout')")
                th.sticky-position.text-right.sortable(width="8%" @click="sortOrder('winlose')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                    i(:class="changeSortKey('winlose')")
            tbody.clusterize-content
              tr(v-if="gameResultList.length == 0")
                td(colspan="10").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in gameResultList" :key="item.result_id || index")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span.cell-primary(:title="$t('ui.result_id')") {{ item.result_id }}
                  br
                  span.cell-secondary(:title="$t('ui.bet_time')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
                  br
                  span.cell-secondary(:title="$t('ui.result_time')") {{ $moment(item.result_time).format('YYYY-MM-DD, HH:mm:ss') }}
                  br
                  span.cell-muted(v-if="item.ip" :title="$t('ui.ip')") {{ item.ip }}
                td
                  span(:title="item.member_id") {{ item.member_id }}
                td
                  span(:title="item.sports_category") {{ item.sports_category }}
                  template(v-if="item.game_type_name")
                    br
                    span.cell-secondary(:title="item.game_type_name") {{ item.game_type_name }}
                td
                  template(v-if="!['IB','CM','S3'].includes(item.provider_code)")
                    template(v-if="item.bet_type != 'PARLAY'")
                      template(v-if="item.result_id.startsWith('9W_')")
                        span.cell-muted(v-if="item.provider_code") {{ item.provider_code }}
                        span.cell-primary(:title="item.league_name") {{ item.league_name }}
                        template(v-if="item.game_type_name")
                          br
                          span.text-success(:title="item.game_type_name") {{ item.game_type_name.split(" v ")[0] }}
                          span.cell-vs vs
                          span.text-danger(:title="item.game_type_name") {{ item.game_type_name.split(" v ")[1] }}
                      template(v-else)
                        span.cell-muted(v-if="item.provider_code") {{ item.provider_code }}
                        span.cell-primary(:title="item.league_name") {{ item.league_name }}
                        template(v-if="item.home_team_name != null && item.away_team_name != null")
                          br
                          span.text-success(:title="item.home_team_name") {{ item.home_team_name }}
                          span.cell-vs vs
                          span.text-danger(:title="item.away_team_name") {{ item.away_team_name }}
                        br
                        span.cell-secondary.text-info(:title="$t('ui.match_time')") {{ $moment(item.match_time).format('YYYY-MM-DD, HH:mm:ss') }}
                        span.cell-score.text-primary(v-if="item.home_score != null && item.away_score != null" :title="'(' + item.home_score + ' - ' + item.away_score + ')'") {{ '(' + item.home_score + ' - ' + item.away_score + ')' }}
                    template(v-else)
                      span.cell-primary(:title="$t('ui.mix_parlay')") {{ $t("ui.mix_parlay") }}
                      br
                      span.cell-secondary(:title="item.odds_display_bet") {{ item.odds_display_bet }}
                td
                  template(v-if="!['IB','CM','S3'].includes(item.provider_code)")
                    span(:title="item.bet_type") {{ item.bet_type }}
                    template(v-if="item.bet_hand")
                      br
                      span(:title="item.bet_hand") {{ item.bet_hand }}
                    template(v-if="item.odds_display != null")
                      br
                      span.cell-secondary(:title="item.odds_display + ' ' + getOddsType(item.odds_type)") {{ item.odds_display + ' ' + getOddsType(item.odds_type) }}
                  template(v-else)
                    i.fas.fa-comment-dots.text-primary(
                      role="button"
                      :title="$t('ui.remark')"
                      style="cursor: pointer;"
                      @click="openRemarkModal(item.remark, item.provider_code)"
                    )
                td.text-right.cell-amount
                  span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                td.text-right.cell-amount
                  span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                td.text-right.cell-amount
                  span.font-weight-bold(:class="$helpers.fontClassName(item.payout)" :title="$n(item.payout, 'currency')") {{ $n(item.payout, 'currency') }}
                td.text-right.cell-amount
                  span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                  //- td.text-center
                  //-   i.fa.ml-1(size="sm" @click="onOffDetail(item)" :class="currId == item.result_id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                //- tr(v-if="isShowDetail == true && currId == item.result_id")
                //-   td(colspan="10")
                //-     table.tablex(style="width: 100%;")
                //-       thead
                //-         tr
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.match_time')") {{ $t("ui.match_time") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.league_name')") {{ $t("ui.league_name") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.home_team_name')") {{ $t("ui.home_team_name") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.away_team_name')") {{ $t("ui.away_team_name") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.home_score')") {{ $t("ui.home_score") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.away_score')") {{ $t("ui.away_score") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.wl_status')") {{ $t("ui.wl_status") }}
                //-       tbody.clusterize-content
                //-         td
                //-           span(:title="$moment(item.match_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.match_time).format('YYYY-MM-DD, HH:mm:ss') }}
                //-         td
                //-           span(:title="item.league_name") {{ item.league_name }}
                //-         td.text-center
                //-           span(:title="item.home_team_name") {{ item.home_team_name }}
                //-         td.text-center
                //-           span(:title="item.away_team_name") {{ item.away_team_name }}
                //-         td.text-center
                //-           span(:title="item.home_score") {{ item.home_score }}
                //-         td.text-center
                //-           span(:title="item.away_score") {{ item.away_score }}
                //-         td.text-center
                //-           span(:title="item.wl_status") {{ item.wl_status }}
              tr.total-row(v-if="showTotal")
                td.text-right(colspan="6")
                  span {{ $t("ui.sub_total") }}
                  br
                  span {{ $t("ui.grand_total") }}
                td.text-right.cell-amount
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
                td.text-right.cell-amount
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
                td.text-right.cell-amount
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalPayout)" :title="$n(subTotalPayout, 'currency')") {{ $n(subTotalPayout, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalPayout)" :title="$n(grandTotalPayout, 'currency')") {{ $n(grandTotalPayout, 'currency') }}
                td.text-right.cell-amount
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
                //- td
                //- td
              //- td
    b-modal#remarkModal(
      ref="remarkModal"
      :title="$t('ui.remark')"
      hide-footer
      centered
      no-fade
      @hidden="resetRemarkModal"
    )
      //- template(v-if="selectedRemarkParts.length")
      //-   p.mb-0.text-break(
      //-     v-for="(remarkLine, idx) in selectedRemarkParts"
      //-     :key="idx"
      //-     style="white-space: pre-line;"
      //-   ) {{ remarkLine }}
      template(v-if="selectedRemark")
        p.mb-0.text-break(style="white-space: pre-line;") {{ selectedRemark }}
      template(v-else)
        p.mb-0.text-break {{ $t('message.no_data_available') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcel.vue";
import gameResultSportsbookExport from "@/components/report/gameResultSportsbookExportFull.vue";
import ProviderLookup from "@/library/ProviderLookup.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    gameResultSportsbookExport,
    ProviderLookup
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    gameResultList: [],
    currentPage: 1,
    totalRow: 0,
    provider: "",
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalPayout: 0,
    grandTotalPayout: 0,
    showTotal: false,
    selectedRemark: '',
    selectedRemarkParts: [],
    selectedProviderCode: '',
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    sortKey: "bet_time",
    sortType: "desc",
    currId: null,
    isShowDetail: false,
    displayTable: false,
    searchCreatedDate: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberReport;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
  },
  mounted: function() {  },
  destroyed: function() {
    var json = {
      start_date: null,
      end_date: null,
      provider: null,
      search_created_date: false
    };
    this.$store.dispatch("user/setGameResultSportsbookParam", json);
  },
  methods: {
    refresh() {
      this.displayTable = false;

      if (this.$store.getters.gameResultSportsbook.search_created_date != null && this.$store.getters.gameResultSportsbook.search_created_date != '') {
        this.searchCreatedDate = this.$store.getters.gameResultSportsbook.search_created_date;
      }

      if (this.$store.getters.gameResultSportsbook.provider != null && this.$store.getters.gameResultSportsbook.provider != '') {
        this.provider = this.$store.getters.gameResultSportsbook.provider;
      }

      if (this.$store.getters.gameResultSportsbook.start_date && this.$store.getters.gameResultSportsbook.end_date) {
        this.dateRange.startDate = this.$moment(this.$store.getters.gameResultSportsbook.start_date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(this.$store.getters.gameResultSportsbook.end_date).format('YYYY-MM-DD');
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      }

      this.getGameResult(true);

      setTimeout(() => {
        this.displayTable = true;
      }, 10);
    },
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.currId == item.result_id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.result_id;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.result_id;
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getGameResult(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getGameResult(true);
    },
    // getResultDetail(e) {
    //   window.open(config.gameResultDetailUrl + e, "info", "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640");
    // },
    setGameResultSportsbookParam: function() {
      var json = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        provider: null,
        search_created_date: false
      };
      this.$store.dispatch("user/setGameResultSportsbookParam", json);
    },
    getOddsType(n) {
      var result = "";
      switch(n) {
        case 1:
          result = "(MY)";
          break;
        case 2:
          result = "(HK)";
          break;
        case 3:
          result = "(ID)";
          break;
        case 4:
          result = "(DEC)";
          break;
      }
      return result;
    },
    getGameResult: function(isSearch) {
      if (this.checkDateRange()) {
        this.setGameResultSportsbookParam();
        let url = config.gameResultSportsbookUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.memberID,
          provider_code: this.provider,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize,
          search_created_date: this.searchCreatedDate
        };
        if (this.$route.query.reportTab && this.$route.query.reportTab == 'sportsbook') {
          json.search_created_date = true
        }

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.gameresult.length > 0) {
                    this.showTotal = true
                    response.data.ds.gameresult.forEach(value => {
                      this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
                      this.subTotalPayout = parseFloat(this.subTotalPayout) + parseFloat(value["payout"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnover = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLose = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalPayout = response.data.ds.grand_total[0]["payout"];
                    }

                    this.grandTotalList = response.data.ds.grand_total
                    this.gameResultList = response.data.ds.gameresult;
                    this.totalRow = response.data.ds.gameresult.length > 0 ? this.gameResultList[0]["totalrows"] : 0
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.gameResultList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false;
      this.gameResultList = []
      this.totalRow = 0
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalPayout = 0
      this.grandTotalPayout = 0
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'gameresultsportsbook') return
      this.$store.dispatch("layout/setPageSizeMemberReport", pageSize);
      this.currentPage = 1;
      this.getGameResult(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getGameResult();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    openRemarkModal(remark, providerCode) {
      this.selectedProviderCode = providerCode || '';
      this.selectedRemark = remark || '';
      this.selectedRemarkParts = this.buildRemarkParts(this.selectedRemark, this.selectedProviderCode);
      if (this.$refs.remarkModal) {
        this.$refs.remarkModal.show();
      }
    },
    resetRemarkModal() {
      this.selectedRemark = '';
      this.selectedRemarkParts = [];
      this.selectedProviderCode = '';
    },
    buildRemarkParts(remark, providerCode) {
      if (!remark) return [];

      const delimiterMap = {
        S3: '|',
        CM: ',',
        IB: '-'
      };

      const delimiter = delimiterMap[(providerCode || '').toUpperCase()];

      if (!delimiter) return [remark];

      return remark
        .split(delimiter)
        .map(value => value.trim())
        .filter(value => value.length > 0);
    }
  }
};
</script>

<style scoped>
#tblGameResultSportsbook tbody td,
#tblGameResultSportsbook tbody td span,
#tblGameResultSportsbook tbody td div {
  height: auto;
  width: auto;
  max-width: 100%;
  margin: 0;
  padding: 0;
  vertical-align: baseline;
  line-height: 1.35;
}

#tblGameResultSportsbook tbody td {
  padding: 6px 8px;
  vertical-align: top;
}

#tblGameResultSportsbook tbody td span {
  white-space: nowrap;
}

#tblGameResultSportsbook .cell-primary {
  font-weight: 700;
}

#tblGameResultSportsbook .cell-secondary {
  color: #5c5663;
}

#tblGameResultSportsbook .cell-muted {
  color: #8b8494;
  font-size: 10px;
}

#tblGameResultSportsbook .cell-muted + .cell-primary {
  margin-left: 4px;
}

#tblGameResultSportsbook .cell-vs {
  color: #6c757d;
  padding: 0 4px;
}

#tblGameResultSportsbook .cell-score {
  margin-left: 4px;
}

#tblGameResultSportsbook .cell-amount {
  font-variant-numeric: tabular-nums;
}

#tblGameResultSportsbook tbody tr.total-row td {
  background: #f4f1f6;
  border-top: 2px solid #d4ced8;
  font-weight: 600;
  vertical-align: middle;
}
</style>
